import React from "react";
import { motion } from "framer-motion";
import {
  FaArrowRight,
  FaClock,
  FaLeaf,
} from "react-icons/fa";

/* ─────────────────────────────────────
   PREMIUM PARAM DESIGN SYSTEM
───────────────────────────────────── */

const T = {
  orange: "#F28C28",
  orange2: "#F6A04D",

  cream: "#FAF8F5",
  cream2: "#F7F2EC",

  brown: "#24160F",
  brown2: "#5E4638",

  text: "#1F140F",
  text2: "#6B574A",
  text3: "#9B8575",

  white: "#FFFFFF",

  border: "rgba(255,255,255,.18)",
};

/* ───────────────────────────────────── */

const quizData = [
{
image: "/assets/knowyourself/quiz/q1.jpg",
title: "Prakriti Quiz",
content:
"Discover your unique Ayurvedic constitution—Vata, Pitta, or Kapha. Understand your natural strengths, tendencies, and imbalances to make better lifestyle, diet, and wellness choices.",
link: "/wellness-quiz/know-your-prakriti",
},

{
image: "/assets/knowyourself/quiz/q2.jpg",
title: "Holistic Wellness Test",
content:
"Get a snapshot of your overall wellbeing across physical, mental, emotional, spiritual, and professional life. Identify strengths and uncover opportunities for greater balance and fulfillment.",
link: "/wellness-quiz/holistic-wellness-test",
},

{
image: "/assets/knowyourself/quiz/q3.jpg",
title: "Body Tox Level Quiz",
content:
"Find out whether toxin accumulation may be affecting your energy, digestion, and vitality. Gain insights into hidden imbalances and where your body may need cleansing and rejuvenation.",
link: "/wellness-quiz/body-toxin-level",
},

{
image: "/assets/knowyourself/quiz/q11.jpeg",
title: "Guna Proportion Self-Assessment",
content:
"Explore the balance of Sattva (clarity), Rajas (activity), and Tamas (inertia) in your life. Understand the inner forces shaping your thoughts, emotions, and behaviors.",
link: "/wellness-quiz/guna-self-assessment",
},

{
image: "/assets/knowyourself/quiz/q9.jpeg",
title: "Emotional Wellbeing Assessment",
content:
"Assess your emotional resilience, self-awareness, and ability to handle life's challenges. Discover patterns that may be helping or draining your emotional wellbeing.",
link: "/wellness-quiz/emotional-wellbeing",
},

{
image: "/assets/knowyourself/quiz/q8.jpeg",
title: "Gut Health Self-Assessment",
content:
"Evaluate how well your digestion supports your energy and overall wellbeing. Uncover habits and patterns that may contribute to bloating, discomfort, fatigue, or digestive imbalance.",
link: "/wellness-quiz/gut-health",
},

{
image: "/assets/knowyourself/quiz/q10.jpeg",
title: "Self-Love Self-Assessment",
content:
"Discover how you treat yourself through self-care, boundaries, and self-worth. Gain awareness of habits that may be strengthening—or limiting—your relationship with yourself.",
link: "/wellness-quiz/self-love",
},

{
image: "/assets/knowyourself/quiz/q7.jpeg",
title: "Integrity Self-Assessment",
content:
"Measure how closely your actions align with your values and commitments. Learn where you may be compromising your inner truth and how greater alignment can create confidence and peace.",
link: "/wellness-quiz/integrity",
},

{
image: "/assets/knowyourself/quiz/q5.jpeg",
title: "Nutrition & Healthy Eating",
content:
"Test your understanding of healthy eating, digestion, and nutrition habits. Separate facts from myths and build a stronger foundation for making healthier food choices.",
link: "/wellness-quiz/nutrition-knowledge",
},

{
image: "/assets/knowyourself/quiz/q4.jpeg",
title: "Sleep & Recovery Assessment",
content:
"Discover how sleep, stress, energy, and daily habits influence your wellbeing. Gain practical insights into routines that can improve rest, recovery, and daily performance.",
link: "/wellness-quiz/sleep-stress-awareness",
},
];

/* ─────────────────────────────────────
   PREMIUM QUIZ CARD
───────────────────────────────────── */

const QuizCard = ({ item }) => {
  return (
    <motion.div
      whileHover={{
        y: -8,
      }}
      transition={{
        duration: 0.35,
      }}
      style={{
        position: "relative",
        borderRadius: 36,
        overflow: "hidden",
        height: 520,
        background: "#000",
        boxShadow:
          "0 30px 80px rgba(20,10,0,.12)",
      }}
    >
      {/* IMAGE */}
      <img
        src={item.image}
        alt={item.title}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          filter:
            "brightness(.84) saturate(.9)",
          transform: "scale(1.02)",
        }}
      />

      {/* DARK OVERLAY */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: `
            linear-gradient(
              to top,
              rgba(0,0,0,.82),
              rgba(0,0,0,.25),
              transparent 40%
            )
          `,
        }}
      />

      {/* TOP TAG */}
      <div
        style={{
          position: "absolute",
          top: 24,
          left: 24,
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          padding: "10px 16px",
          borderRadius: 999,
          background: "rgba(255,255,255,.12)",
          backdropFilter: "blur(16px)",
          border: "1px solid rgba(255,255,255,.1)",
          color: "#fff",
          fontSize: 12,
          letterSpacing: ".05em",
        }}
      >
        <FaLeaf size={11} />
        {item.tag}
      </div>

      {/* CONTENT */}
      <div
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          padding: 30,
        }}
      >
        {/* FLOATING GLASS PANEL */}
        <div
          style={{
            background: "rgba(255,255,255,.12)",
            backdropFilter: "blur(22px)",
            borderRadius: 30,
            padding: 28,
            border: "1px solid rgba(255,255,255,.12)",
          }}
        >
          {/* META */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 14,
              marginBottom: 18,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                color: "rgba(255,255,255,.72)",
                fontSize: 13,
              }}
            >
              <FaClock size={11} />
              {item.duration}
            </div>
          </div>

          {/* TITLE */}
          <h2
            style={{
              fontSize: 30,
              lineHeight: 1.08,
              color: "#FFF8F2",
              fontWeight: 500,
              marginBottom: 16,
               letterSpacing: "-0.02em",
            }}
          >
            {item.title}
          </h2>

          {/* DESCRIPTION */}
          <p
            style={{
              color: "rgba(255,255,255,.72)",
              lineHeight: 1.8,
              fontSize: 15,
              marginBottom: 28,
            }}
          >
            {item.content}
          </p>

          {/* CTA */}
          <a
            href={item.link}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 12,
              height: 54,
              padding: "0 24px",
              borderRadius: 999,
              background:
                "linear-gradient(135deg,#F28C28,#F6A04D)",
              color: "#fff",
              textDecoration: "none",
              fontWeight: 600,
              fontSize: 14,
              boxShadow:
                "0 14px 34px rgba(242,140,40,.24)",
            }}
          >
            Begin Quiz
            <FaArrowRight size={12} />
          </a>
        </div>
      </div>
    </motion.div>
  );
};

/* ─────────────────────────────────────
   MAIN SECTION
───────────────────────────────────── */

const QuizSection = () => {
  return (
    <section
      style={{
        position: "relative",
        overflow: "hidden",
        padding: "120px 24px",
        background: `
          radial-gradient(circle at top left,
          rgba(242,140,40,.10),
          transparent 26%),

          ${T.cream}
        `,
      }}
    >
      {/* AMBIENT GLOW */}
      <div
        style={{
          position: "absolute",
          width: 500,
          height: 500,
          borderRadius: "50%",
          background: "rgba(242,140,40,.08)",
          filter: "blur(120px)",
          top: -180,
          right: -120,
        }}
      />

      <div
        style={{
          maxWidth: 1320,
          margin: "0 auto",
        }}
      >
        {/* HEADER */}
        <div
          style={{
            textAlign: "center",
            marginBottom: 80,
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "8px 16px",
              borderRadius: 999,
              background: "#FFF1E4",
              color: T.orange,
              fontSize: 12,
              fontWeight: 600,
              letterSpacing: ".08em",
              marginBottom: 24,
            }}
          >
            KNOW YOURSELF
          </div>

          <h1
            style={{
                 fontWeight: 400,
              fontSize: "clamp(42px,6vw,78px)",
              lineHeight: 1.05,
              color: T.brown,
              letterSpacing: "-0.04em",
              marginBottom: 24,
            }}
          >
            Wellness quizzes
            <br />
            for deeper self-awareness
          </h1>

          <p
            style={{
              maxWidth: 760,
              margin: "0 auto",
              color: T.text2,
              lineHeight: 1.9,
              fontSize: 17,
            }}
          >
            Explore guided assessments inspired by
            Ayurveda, mindfulness, emotional wellbeing,
            and holistic living to understand yourself
            more deeply.
          </p>
        </div>

        {/* GRID */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(340px,1fr))",
            gap: 30,
          }}
        >
          {quizData.map((item, index) => (
            <QuizCard
              key={index}
              item={item}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuizSection;